import {BehaviorSubject} from "rxjs";
import {Products} from "./models/products";
import {Orders} from "./models/orders";

export class SharedResources {
  public static currentScreen: string = 'orders'
  public static _currentScreenBS: any = new BehaviorSubject<any>('')


  public static currentEditProduct: Products = new Products();
  public static currentProductPage: number = 1
  public static currentProductSortColumn: string = 'PARTNO'
  public static currentProductSearchWord: string = ''
  public static currentProductSortDesc: boolean = false;


  public static currentEditOrder: Orders = new Orders();
  public static currentOrderPage: number = 1
  public static currentOrderSortColumn: string = 'DATARECEPTIE'
  public static currentOrderSearchWord: string = ''
  public static currentOrderSortDesc: boolean = false;
  public static currentOrderDateStart: Date = new Date(2000, 1, 1);
  public static currentOrderDateEnd: Date = new Date(2030, 12, 31);
  public static currentOrderStates: string = '';



  public static _isLoadingBS: any = new BehaviorSubject<any>(false)
  static currentProcessedOrder: Orders = new Orders();

}
